import React from 'react';
import { View } from 'react-native';
import { AreaChart, Area, ResponsiveContainer, YAxis } from 'recharts';

type Point = { day: string; totalKwh: number };
type Props = { data: Point[]; width?: number; height?: number; strokeColor?: string; strokeWidth?: number };

export default function SparklineChart({ data, width = 120, height = 100, strokeColor = '#39BEB7', strokeWidth = 2 }: Props) {
  const chartData = React.useMemo(() => data.map((p, i) => ({ x: i, y: p.totalKwh || 0 })), [data]);
  
  return (
    <View style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 5, right: 0, left: 0, bottom: 5 }}>
          <defs>
            <linearGradient id="sparklineGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={strokeColor} stopOpacity={0.4} />
              <stop offset="100%" stopColor="#14374C" stopOpacity={0.1} />
            </linearGradient>
          </defs>
          <YAxis domain={['auto', 'auto']} hide />
          <Area 
            type="monotone" 
            dataKey="y" 
            stroke={strokeColor} 
            strokeWidth={strokeWidth}
            fill="url(#sparklineGradient)" 
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </View>
  );
}


